import React from 'react';
import ReactSwitch from "react-switch";
import { colors } from '../theme/index.js';

/**
 * @param checked
 * @param color
 * @param onChange
 * @returns {JSX.Element}
 * @constructor
 */
const Switch = ({
  checked,
  color,
  onChange,
  disabled = false
}) => /*#__PURE__*/React.createElement(ReactSwitch, {
  checked: checked || false,
  onChange: onChange,
  onColor: color || colors.lightGreen,
  onHandleColor: "#FFF",
  uncheckedIcon: false,
  checkedIcon: false,
  disabled: disabled
});
export default Switch;